module.exports = __webpack_public_path__ + "img/iconR.99435223.jpg";